/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import {Button} from "@blueprintjs/core";
import {Intent} from "@blueprintjs/core/lib/esm/index";
import {WrcSchedulingInputCP} from "./WrcSchedulingInputCP.js";

export class WrcScheduleOpener extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            canOutsideClickClose: false,
            is_loaded: false,
        };
    }

    showSchedule() {
        ReactDOM.render(
            <WrcSchedulingInputCP
                    refresh={this.props.refresh}
                    component_index={this.props.component_index}
                    page_length={this.props.page_length}
                    registry={this.props.registry}
                    configure_component={this.props.configure_component}
                    import_conditions={this.props.import_conditions ? this.props.import_conditions : undefined}
                />,
            document.querySelector('#schedule'));
    }

    componentDidMount() {
        this.setState({
            is_loaded: true
        });
    }

    render() {
        if (this.state.is_loaded) {
            return (
                <div className="wd-record">
                    <Button icon='calendar'
                            intent={Intent.PRIMARY}
                            text={this.props.button_text}
                            style={{marginTop: '1em'}}
                            fill={false}
                            onClick={() => this.showSchedule()} />
                </div>
            );
        }
        else {
            return (<div>Loading...</div>);
        }
    }
}


WrcScheduleOpener.propTypes = {
    button_text: PropTypes.string.isRequired,
    refresh: PropTypes.func,
    component_index: PropTypes.number,
    configure_component: PropTypes.func,
    page_length: PropTypes.number,
    registry: PropTypes.string.isRequired,
};
